import styled, { keyframes, css } from 'styled-components';

export const Wrapper = styled.div`
	height: 100px;
	margin: auto;
	overflow:hidden;
	position: relative;
	width: 100%;
`;

const scroll = (width) => keyframes`
	0% { transform: translateX(0); }
	100% { transform: translateX(-${width}px)}
`;

export const SlideTrack = styled.div`
	animation: ${(props) => css`${scroll(props.width)} ${props.time}s`} linear infinite;
	display: inline-flex;
	width: ${(props) => props.width ? `${props.width}px` : 'auto'};
`;

export const Slide = styled.div`
	display: inline-table;
`;
